import Container from 'components/Container'
import PostCard from 'components/PostCard'
import PropTypes from 'prop-types'
import React from 'react'
import theme from 'styles/theme'

const PostsList = ({ posts }) => (
  <Container>
    <div
      css={{
        margin: '5rem auto',
        [theme.medium]: {
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gridGap: '2rem 5%',
        },
      }}
    >
      {posts &&
        posts.map((post, idx) => (
          <PostCard
            key={post.id}
            cardStyles={{
              gridColumn: idx % 5 === 0 ? 'span 2' : '',
              '.image-wrapper': {
                paddingBottom: idx % 5 === 0 ? '46.1538%' : '100%',
              },
            }}
            {...post}
          />
        ))}
    </div>
  </Container>
)

PostsList.propTypes = {
  posts: PropTypes.array.isRequired,
}

export default PostsList
